module.exports = __webpack_public_path__ + "img/gif_menu.c321d327.gif";